import React from "react";
import "./Cards.css";
import EMEIGym from "../../Assets/EMEI-GYM.jpeg";
import EMEIcafeteria from "../../Assets/EMEI-CAFE.jpeg";
import EMEIclassroom from "../../Assets/EMEI-LIBRARY.jpeg";
function Cards() {
  return (
    <>


      {/* Cards Section */}
<section className="mini_cards">

  <div
    className="mini_card"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="0"
    data-aos-once="true"
  >
    <img
      src={EMEIGym}
      alt="icon"
      className="card-icon"
    />
    <h3>EMEI's GYM</h3>
    <p>A healthy body supports a focused mind. EMEI Gym provides students and staff with a dedicated space to stay active, improve fitness, and maintain a healthy lifestyle alongside their academic journey.</p>
  </div>

  <div
    className="mini_card"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="150"
    data-aos-once="true"
  >
    <img
      src={EMEIcafeteria}
      alt="icon"
      className="card-icon"
    />
    <h3>EMEI's Cafeteria</h3>
    <p>Enjoy a variety of delicious meals and snacks at EMEI's cafeteria, designed to fuel your day with nutritious options that support your academic pursuits.</p>
  </div>

  <div
    className="mini_card"
    data-aos="fade-up"
    data-aos-duration="800"
    data-aos-delay="300"
    data-aos-once="true"
  >
    <img
      src={EMEIclassroom}
      alt="icon"
      className="card-icon"
    />
    <h3>EMEI's Library</h3>
    <p>Experience modern learning environments at EMEI, equipped with state-of-the-art facilities to enhance your educational journey.</p>
  </div>

</section>
    </>
  );
}

export default Cards;
